export const ALERTS = {
  DUPLICATE: 'DUPLICATE',
  WITHOUT_TICKET: 'WITHOUT_TICKET',
  OUT_OF_ASSIGNED_TIME: 'OUT_OF_ASSIGNED_TIME',
  AMOUNT_EXCEEDED: 'AMOUNT_EXCEEDED',
  AMOUNT_DISTINCT_OCR: 'AMOUNT_DISTINCT_OCR',
  AMOUNT_DISTINCT_SUM_TAXES: 'AMOUNT_DISTINCT_SUM_TAXES'
}
